__turbopack_context__.v({
  "back_action": "Expansion-module-scss-module__681v-G__back_action",
  "back_action_content": "Expansion-module-scss-module__681v-G__back_action_content",
  "content": "Expansion-module-scss-module__681v-G__content",
  "expansion": "Expansion-module-scss-module__681v-G__expansion",
  "expansion_ctas": "Expansion-module-scss-module__681v-G__expansion_ctas",
  "expansion_item": "Expansion-module-scss-module__681v-G__expansion_item",
  "expansion_item_link": "Expansion-module-scss-module__681v-G__expansion_item_link",
  "expansion_level_2": "Expansion-module-scss-module__681v-G__expansion_level_2",
  "section_item": "Expansion-module-scss-module__681v-G__section_item",
  "section_links": "Expansion-module-scss-module__681v-G__section_links",
  "sections": "Expansion-module-scss-module__681v-G__sections",
  "title": "Expansion-module-scss-module__681v-G__title",
  "treatment_back_action": "Expansion-module-scss-module__681v-G__treatment_back_action",
  "treatment_expansion": "Expansion-module-scss-module__681v-G__treatment_expansion",
  "treatment_expansion_ctas": "Expansion-module-scss-module__681v-G__treatment_expansion_ctas",
  "treatment_level_2": "Expansion-module-scss-module__681v-G__treatment_level_2",
});
